import React, { useState, useEffect } from 'react';
import './diario.css';
import { Doughnut } from 'react-chartjs-2';
import axios from 'axios';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Swal from 'sweetalert2';
import { FaEdit, FaClipboardCheck } from 'react-icons/fa';

import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const Diario = () => {
    const [dailyContent, setDailyContent] = useState(null);
    const [diarioData, setDiarioData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // Helper function para obter configuração da API
    const getApiConfig = () => {
        const userIdentifier = localStorage.getItem('userEmail');
        const token = localStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
        const headers = { 'Authorization': `Bearer ${token}` };
        
        if (!userIdentifier) {
            throw new Error('Usuário não identificado. Faça login novamente.');
        }
        
        return { userIdentifier, apiUrl, headers };
    };
    const [pensamento, setPensamento] = useState('');
    const [selectedEmotion, setSelectedEmotion] = useState(null);
    const [checklist, setChecklist] = useState({
        agua: false,
        meditacao: false,
        escreveuDiario: false,
        marcouHumor: false,
        atividadeFisica: false,
        sono: false,
        dieta: false
    });
    const [consistencia, setConsistencia] = useState({
        percentualConsistencia: 0,
        aguaConsumida: 0
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const userIdentifier = localStorage.getItem('userEmail');
                const token = localStorage.getItem('token');
                
                if (!userIdentifier) {
                    throw new Error('Usuário não identificado. Faça login novamente.');
                }
                
                const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
                const headers = {
                    'Authorization': `Bearer ${token}`
                };
                
                // Buscar conteúdo diário (cronograma)
                const cronogramaResponse = await axios.get(`${apiUrl}/api/cronogramas/dia/${userIdentifier}`, { headers });
                setDailyContent(cronogramaResponse.data);
                
                // Buscar dados do diário
                const diarioResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}`, { headers });
                setDiarioData(diarioResponse.data);
                
                // Preencher os estados com os dados do diário
                if (diarioResponse.data) {
                    setPensamento(diarioResponse.data.pensamentoDoDia || '');
                    setSelectedEmotion(diarioResponse.data.estadoEmocional || null);
                    setChecklist(diarioResponse.data.checklist || {
                        agua: false,
                        meditacao: false,
                        escreveuDiario: false,
                        marcouHumor: false,
                        atividadeFisica: false,
                        sono: false,
                        dieta: false
                    });
                }
                
                // Buscar dados de consistência
                const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                setConsistencia(consistenciaResponse.data);
                
                setLoading(false);
            } catch (err) {
                console.error('Erro ao buscar dados:', err);
                setError(err);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const consistencyData = {
        labels: ['Concluído', 'Pendente'],
        datasets: [
            {
                data: [
                    consistencia.percentualConsistencia || 0, 
                    100 - (consistencia.percentualConsistencia || 0)
                ],
                backgroundColor: ['#ff9b2f', '#bdbfbf'],
                hoverBackgroundColor: ['#B90423', '#bdbfbf'],
            },
        ],
        options: {
            responsive: true,
            plugins: {
                tooltip: {
                    enabled: false
                },
                datalabels: {
                    display: false
                },
                legend: {
                    labels: {
                        font: {
                            size: 16,
                            weight: 'bold'
                        },
                        padding: 20,
                        usePointStyle: true
                    },
                    position: 'bottom'
                }
            }
        }
    };

    const hydrationData = {
        labels: ['Consumido', 'Meta Restante'],
        datasets: [
            {
                data: [
                    consistencia.aguaConsumida || 0, 
                    Math.max(0, 16 - (consistencia.aguaConsumida || 0))
                ],
                backgroundColor: ['#ff9b2f', '#bdbfbf'],
                hoverBackgroundColor: ['#B90423', '#e0e0e0'],
            },
        ],
        options: {
            responsive: true,
            plugins: {
                tooltip: {
                    enabled: false
                },
                datalabels: {
                    display: false
                },
                legend: {
                    labels: {
                        font: {
                            size: 16,
                            weight: 'bold'
                        },
                        padding: 20,
                        usePointStyle: true
                    },
                    position: 'bottom'
                }
            }
        }
    };



    if (loading) return <div>Carregando...</div>;
    if (error) return <div>Erro ao carregar conteúdo</div>;

    return (
        <div className="Dcontainer">
            <header className="Dheader">
                <h1 className="Dtext-3xl font-bold text-white text-center">Meu Diário</h1>
                <p className="Dtext-lg text-white text-center">{new Date().toLocaleDateString()}</p>
            </header>

            <div className="Dcard bg-gradient-to-r from-orange-50 to-orange-100 shadow-lg rounded-xl p-8 max-w-md mx-auto">
                <div className="flex items-center mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-orange-600 mr-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707.707m2.828 9.9a5 5 0 117.071 0l-.172.171a3 3 0 01-.86.722l-.261.149a3 3 0 00-1.458.44 3 3 0 01-2.25.534l-.578-.114a3 3 0 01-2.15-1.622l-.083-.188a3 3 0 00-1.623-1.622l-.188-.083a3 3 0 01-.44-1.458v-.886a3 3 0 01.534-2.25l.114-.578a3 3 0 011.622-2.15l.188-.083a3 3 0 001.622-1.623l.083-.188z" />
                    </svg>
                    <h2 className="text-3xl font-bold text-black">Pílulas da Mente Magra</h2>
                </div>
                
                <div className="bg-white rounded-lg p-4 shadow-md flex flex-col items-center">
                    <blockquote className="italic text-gray-800 text-2xl mb-4 border-l-2 border-orange-500 pl-4 w-11/12">
                        "{dailyContent?.diario?.frase || 'A mudança começa em pequenos passos.'}"
                    </blockquote>
                    
                    <div className="flex flex-col w-4/5 space-y-4">
                        <div className="bg-orange-50 rounded-lg p-3 overflow-hidden">
                            <p className="text-base text-gray-600 uppercase font-semibold truncate">Semanana</p>
                            <p className="text-2xl font-bold text-orange-800 truncate">{dailyContent?.diario?.semana || '-'}</p>
                        </div>
                        <div className="bg-orange-50 rounded-lg p-3">
                            <p className="text-base text-gray-600 uppercase font-semibold">Dia</p>
                            <p className="text-2xl font-bold text-orange-800">{dailyContent?.diario?.dia || '-'}</p>
                        </div>
                        <div className="bg-orange-50 rounded-lg p-3 overflow-hidden">
                            <p className="text-base text-gray-600 uppercase font-semibold truncate">Dias no Programa</p>
                            <p className="text-2xl font-bold text-orange-800 truncate">{dailyContent?.diario?.diasNoPrograma || '-'}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="Dcard bg-gradient-to-r from-orange-50 to-orange-100 shadow-lg rounded-xl p-8">
                <div className="flex items-center mb-6">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 text-orange-500 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    <h2 className="text-2xl font-bold text-gray-800">Escreva no Diário</h2>
                </div>
                
                <div className="relative mb-6">
                    <textarea
                        className="w-full p-5 border-2 border-orange-200 rounded-xl bg-white shadow-inner focus:border-orange-400 focus:ring focus:ring-orange-200 focus:ring-opacity-50 transition duration-300 ease-in-out"
                        rows="5"
                        placeholder="Escreva aqui seus pensamentos do dia..."
                        value={pensamento}
                        onChange={(e) => setPensamento(e.target.value)}
                        style={{ resize: 'none' }}
                    ></textarea>
                </div>
                
                <div className="flex justify-end">
                    <button 
                        className="px-6 py-3 bg-orange-500 text-white font-medium rounded-lg shadow-md hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300 transition duration-300 ease-in-out transform hover:scale-105 flex items-center"
                        onClick={async () => {
                            try {
                                const userIdentifier = localStorage.getItem('userEmail');
                                const token = localStorage.getItem('token');
                                const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
                                const headers = { 'Authorization': `Bearer ${token}` };
                                
                                if (!userIdentifier) {
                                    throw new Error('Usuário não identificado');
                                }
                                
                                await axios.post(`${apiUrl}/api/diario/${userIdentifier}/pensamento`, { pensamento }, { headers });
                                Swal.fire({
                                    title: 'Sucesso!',
                                    text: 'Seu pensamento foi salvo com sucesso!',
                                    icon: 'success',
                                    confirmButtonColor: '#ff9b2f'
                                });
                                
                                // Atualizar checklist
                                setChecklist(prev => ({ ...prev, escreveuDiario: true }));
                                
                                // Atualizar consistência
                                const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                setConsistencia(consistenciaResponse.data);
                            } catch (error) {
                                console.error('Erro ao salvar pensamento:', error);
                                Swal.fire({
                                    title: 'Erro!',
                                    text: 'Ocorreu um erro ao salvar seu pensamento.',
                                    icon: 'error',
                                    confirmButtonColor: '#ff9b2f'
                                });
                            }
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                        </svg>
                        Salvar
                    </button>
                </div>
            </div>

            <div className="Dcard">
                <h2 className="text-2xl font-bold text-black mb-6 text-center">Como Você Está se Sentindo?</h2>
                <div className="grid grid-cols-3 gap-4">
                    {[
                        { emoji: '😊', label: 'Feliz' },
                        { emoji: '😔', label: 'Triste' },
                        { emoji: '😡', label: 'Raiva' },
                        { emoji: '😨', label: 'Ansioso' },
                        { emoji: '🥰', label: 'Amado' },
                        { emoji: '😴', label: 'Cansado' },
                        { emoji: '🤔', label: 'Pensativo' },
                        { emoji: '😌', label: 'Calmo' },
                        { emoji: '😓', label: 'Estressado' },
                        { emoji: '🤩', label: 'Inspirado' },
                        { emoji: '😢', label: 'Melancólico' },
                        { emoji: '🤗', label: 'Acolhido' }
                    ].map((emotion, index) => (
                        <button 
                            key={index} 
                            className={`
                                flex flex-col items-center justify-center 
                                p-3 rounded-xl 
                                transition-all duration-300 ease-in-out
                                transform hover:scale-105 
                                focus:outline-none focus:ring-2 focus:ring-primary-500
                                ${selectedEmotion && selectedEmotion.label === emotion.label 
                                    ? 'bg-orange-300' 
                                    : 'bg-orange-100 hover:bg-orange-200'}
                                h-full
                                min-h-[100px]
                            `}
                            onClick={async () => {
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/emocional`, { 
                                        estadoEmocional: emotion 
                                    }, { headers });
                                    
                                    setSelectedEmotion(emotion);
                                    
                                    // Atualizar checklist
                                    setChecklist(prev => ({ ...prev, marcouHumor: true }));
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao salvar estado emocional:', error);
                                    Swal.fire({
                                        title: 'Erro!',
                                        text: 'Ocorreu um erro ao registrar sua emoção.',
                                        icon: 'error',
                                        confirmButtonColor: '#ff9b2f'
                                    });
                                }
                            }}
                        >
                            <span className="text-3xl mb-2">{emotion.emoji}</span>
                            <span className="text-sm font-medium text-gray-700 text-center">
                                {emotion.label}
                            </span>
                        </button>
                    ))}
                </div>
            </div>

            <div className="Dcard">
                <h2 className="text-2xl font-semibold mb-4 text-left">Checklist do Dia</h2>
                <div className="space-y-2 text-left">
                    <label className="flex items-center">
                        <input 
                            type="checkbox" 
                            className="mr-2" 
                            checked={checklist.agua || false}
                            onChange={async (e) => {
                                const newValue = e.target.checked;
                                setChecklist(prev => ({ ...prev, agua: newValue }));
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/checklist`, { 
                                        agua: newValue 
                                    }, { headers });
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao atualizar checklist:', error);
                                }
                            }}
                        />
                        Bebi 2 litros de água
                    </label>
                    <label className="flex items-center">
                        <input 
                            type="checkbox" 
                            className="mr-2" 
                            checked={checklist.meditacao || false}
                            onChange={async (e) => {
                                const newValue = e.target.checked;
                                setChecklist(prev => ({ ...prev, meditacao: newValue }));
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/checklist`, { 
                                        meditacao: newValue 
                                    }, { headers });
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao atualizar checklist:', error);
                                }
                            }}
                        />
                        Meditei sobre as pílulas diárias
                    </label>
                    <label className="flex items-center">
                        <input 
                            type="checkbox" 
                            className="mr-2" 
                            checked={checklist.escreveuDiario || false}
                            onChange={async (e) => {
                                const newValue = e.target.checked;
                                setChecklist(prev => ({ ...prev, escreveuDiario: newValue }));
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/checklist`, { 
                                        escreveuDiario: newValue 
                                    }, { headers });
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao atualizar checklist:', error);
                                }
                            }}
                        />
                        Escrevi no diário
                    </label>
                    <label className="flex items-center">
                        <input 
                            type="checkbox" 
                            className="mr-2" 
                            checked={checklist.marcouHumor || false}
                            onChange={async (e) => {
                                const newValue = e.target.checked;
                                setChecklist(prev => ({ ...prev, marcouHumor: newValue }));
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/checklist`, { 
                                        marcouHumor: newValue 
                                    }, { headers });
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao atualizar checklist:', error);
                                }
                            }}
                        />
                        Marquei o humor do dia
                    </label>
                    <label className="flex items-center">
                        <input 
                            type="checkbox" 
                            className="mr-2" 
                            checked={checklist.atividadeFisica || false}
                            onChange={async (e) => {
                                const newValue = e.target.checked;
                                setChecklist(prev => ({ ...prev, atividadeFisica: newValue }));
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/checklist`, { 
                                        atividadeFisica: newValue 
                                    }, { headers });
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao atualizar checklist:', error);
                                }
                            }}
                        />
                        Concluí a meta de atividade física
                    </label>
                    <label className="flex items-center">
                        <input 
                            type="checkbox" 
                            className="mr-2" 
                            checked={checklist.sono || false}
                            onChange={async (e) => {
                                const newValue = e.target.checked;
                                setChecklist(prev => ({ ...prev, sono: newValue }));
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/checklist`, { 
                                        sono: newValue 
                                    }, { headers });
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao atualizar checklist:', error);
                                }
                            }}
                        />
                        Dormi 8 horas
                    </label>
                    <label className="flex items-center">
                        <input 
                            type="checkbox" 
                            className="mr-2" 
                            checked={checklist.dieta || false}
                            onChange={async (e) => {
                                const newValue = e.target.checked;
                                setChecklist(prev => ({ ...prev, dieta: newValue }));
                                try {
                                    const { userIdentifier, apiUrl, headers } = getApiConfig();
                                    await axios.post(`${apiUrl}/api/diario/${userIdentifier}/checklist`, { 
                                        dieta: newValue 
                                    }, { headers });
                                    
                                    // Atualizar consistência
                                    const consistenciaResponse = await axios.get(`${apiUrl}/api/diario/${userIdentifier}/consistencia`, { headers });
                                    setConsistencia(consistenciaResponse.data);
                                } catch (error) {
                                    console.error('Erro ao atualizar checklist:', error);
                                }
                            }}
                        />
                        Segui a dieta correta
                    </label>
                </div>
            </div>

            <div className="Dgrid md:grid-cols-2 gap-4">
                <div className="Dcard">
                    <h2 className="text-2xl font-semibold mb-4">Consistência nas Atividades</h2>
                    <div className="Dchart-container">
                        <Doughnut 
                            data={consistencyData} 
                            options={consistencyData.options} 
                            plugins={[]} 
                        />
                    </div>
                    <p className="text-center mt-4">Registros no diário: {consistencia.percentualConsistencia || 0}%</p>
                </div>

                <div className="Dcard">
                    <h2 className="text-2xl font-semibold mb-4">Hidratação Semanal</h2>
                    <div className="Dchart-container">
                        <Doughnut 
                            data={hydrationData} 
                            options={hydrationData.options} 
                            plugins={[]} 
                        />
                    </div>
                    <p className="text-center mt-4">Água consumida esta semana: {consistencia.aguaConsumida || 0}L</p>
                </div>
            </div>
        </div>
    );
};

export default Diario;
